<template functional>
  <div class="ine-form__background">
    <img
      class="ine-form__logo"
      src="@/assets/images/home-logo.png"
      alt="INE logo"
    />
  </div>
</template>

<script>
export default {
  name: 'Background',
}
</script>
